import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { Radio } from './radio.js';
import { jsx } from '@emotion/react';

var RadioGroup = function RadioGroup(_ref) {
  var parentChildren = _ref.children,
      group = _ref.group,
      onChange = _ref.onChange,
      selected = _ref.selected,
      size = _ref.size;
  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedID = _React$useState2[0],
      setSelectedID = _React$useState2[1];
  return parentChildren && (parentChildren === null || parentChildren === void 0 ? void 0 : parentChildren.length) > 0 && jsx(React.Fragment, null, parentChildren.map(function (child) {
    var _child$props = child.props,
        children = _child$props.children,
        id = _child$props.id,
        value = _child$props.value;
    if (child.type.displayName === 'Radio') {
      return jsx(Radio, {
        key: id,
        group: group,
        handleSelected: function handleSelected() {
          setSelectedID(id);
          if (onChange) {
            onChange(value);
          }
        },
        id: id,
        isSelected: selected !== undefined ? value === selected : selectedID === id,
        size: size,
        value: value
      }, children);
    }
    throw new Error('Only Radio components may be passed to RadioGroup');
  })) || null;
};
RadioGroup.displayName = 'RadioGroup';
RadioGroup.defaultProps = {
  size: 'l'
};

export { RadioGroup };
//# sourceMappingURL=radio-group.js.map
